import DashboardCenterNotifications from "../components/notifications/DashboardCenterNotifications";

export default function Notifications() {
  return (
    <DashboardCenterNotifications />
  );
}
